module.exports = __webpack_public_path__ + "img/8716ffd4849843188b19b9c8cd7ded77.691b843d.jpg";